import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Hero from './components/Hero';
import Highlights from './components/Highlights';
import FormatGuide from './components/FormatGuide';
import ProcessSection from './components/ProcessSection';
import NotesSection from './components/NotesSection';
import TopicGrid from './components/TopicGrid';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <Highlights />
        <FormatGuide />
        <ProcessSection />
        <NotesSection />
        <TopicGrid />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}